import React, { useState } from 'react';
import './EditableListField.css';

/**
 * Редактируемый список строк: добавление, удаление, редактирование элементов.
 * value и onChange — массив строк (подходит для чтения/записи через API в формате JSON array).
 */
function EditableListField({ value = [], onChange, label, placeholder = 'Введите значение', addButtonLabel = '+ Добавить элемент' }) {
  const list = Array.isArray(value) ? [...value] : [];
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingValue, setEditingValue] = useState('');

  const startEdit = (index) => {
    setEditingIndex(index);
    setEditingValue(list[index] ?? '');
  };

  const saveEdit = () => {
    const trimmed = editingValue.trim();
    if (editingIndex === null) return;
    const next = [...list];
    if (editingIndex >= next.length) {
      if (trimmed) next.push(trimmed);
    } else {
      if (trimmed) {
        next[editingIndex] = trimmed;
      } else {
        next.splice(editingIndex, 1);
      }
    }
    onChange(next);
    setEditingIndex(null);
    setEditingValue('');
  };

  const cancelEdit = () => {
    setEditingIndex(null);
    setEditingValue('');
  };

  const removeAt = (index) => {
    const next = list.filter((_, i) => i !== index);
    onChange(next);
    if (editingIndex === index) {
      setEditingIndex(null);
      setEditingValue('');
    } else if (editingIndex !== null && editingIndex > index) {
      setEditingIndex(editingIndex - 1);
    }
  };

  const addNew = () => {
    let next = [...list];
    if (editingIndex !== null) {
      const trimmed = editingValue.trim();
      if (editingIndex >= next.length) {
        if (trimmed) next.push(trimmed);
      } else {
        if (trimmed) {
          next[editingIndex] = trimmed;
        } else {
          next.splice(editingIndex, 1);
        }
      }
      setEditingIndex(null);
      setEditingValue('');
    }
    next = [...next, ''];
    onChange(next);
    setEditingIndex(next.length - 1);
    setEditingValue('');
  };

  return (
    <div className="editable-list-field">
      {label && <label className="editable-list-field-label">{label}</label>}
      <ul className="editable-list-field-list">
        {list.map((item, index) => (
          <li key={index} className="editable-list-field-item">
            {editingIndex === index ? (
              <>
                <input
                  type="text"
                  className="editable-list-field-input"
                  value={editingValue}
                  onChange={(e) => setEditingValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') { e.preventDefault(); saveEdit(); }
                    if (e.key === 'Escape') cancelEdit();
                  }}
                  placeholder={placeholder}
                  autoFocus
                />
                <button type="button" className="editable-list-field-btn editable-list-field-btn-save" onClick={saveEdit} title="Сохранить">✓</button>
                <button type="button" className="editable-list-field-btn editable-list-field-btn-cancel" onClick={cancelEdit} title="Отмена">✕</button>
              </>
            ) : (
              <>
                <span className="editable-list-field-text">{item || '(пусто)'}</span>
                <button type="button" className="editable-list-field-btn editable-list-field-btn-edit" onClick={() => startEdit(index)} title="Редактировать">✏️</button>
                <button type="button" className="editable-list-field-btn editable-list-field-btn-delete" onClick={() => removeAt(index)} title="Удалить">✕</button>
              </>
            )}
          </li>
        ))}
      </ul>
      <button type="button" className="editable-list-field-add" onClick={addNew}>
        {addButtonLabel}
      </button>
    </div>
  );
}

export default EditableListField;
